export default "__VITE_PUBLIC_ASSET__c20f9cfb__"